$(".bg_shadow2").on('click',function(){$("#poster")[0].click();});